module.exports = __webpack_public_path__ + "static/media/Air_Baltic,_YL-CSA,_Bombardier_CS300_(30609837693).2a4e2e20.jpg";